import React, { useState } from "react";
import { Badge, Box, Button, Card, Typography, CardProps } from "@mui/material";

const CustomStepper = ({
  steps = [
    "Interview",
    "Coding Challenge",
    "Technical Interview",
    "Offer",
    "Hired",
  ],
  activeStepProp = 0,
  onStepChange,
  title = "Backend Developer - Remote",
  description = "Turkey (AlU). Engineering, Technology & Product, Engineering, Full-time",
  sx = {},
  ...props
}: {
  steps?: string[];
  activeStepProp?: number;
  onStepChange?: (step: number) => void;
  title?: string;
  description?: string;
  sx?: CardProps["sx"];
} & CardProps) => {
  const [activeStep, setActiveStep] = useState(activeStepProp);

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      const newStep = activeStep + 1;
      setActiveStep(newStep);
      if (onStepChange) {
        onStepChange(newStep);
      }
    }
  };

  return (
    <Card sx={{ boxShadow: 1, pl: 6, py: 2, ...sx }} {...props}>
      <Badge
        color="secondary"
        variant="dot"
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{ ml: -2, span: { mt: 1.7 } }}
      >
        <Typography variant="h6" sx={{ pl: 1.5 }}>
          {title}
        </Typography>
      </Badge>
      <Typography variant="subtitle2" color={"gray"}>
        {description}
      </Typography>

      <Box sx={{ width: "80%", mt: 1 }}>
        <Typography variant="body2">{steps[activeStep]}</Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {steps.map((step, index) => (
            <React.Fragment key={step}>
              <Box
                sx={{
                  height: 4,
                  backgroundColor:
                    index <= activeStep ? "primary.main" : "grey.300",
                  width: "100%",
                  flexGrow: 1,
                  marginRight: index !== steps.length - 1 ? 1 : 0,
                  transition: "background-color 0.3s ease",
                }}
              />
            </React.Fragment>
          ))}
          <Button
            variant="contained"
            onClick={handleNext}
            disabled={activeStep === steps.length - 1}
            sx={{ ml: 2 }}
          >
            Next
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default CustomStepper;
